var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-component-demo',{attrs:{"title":"Button"}},[_c('o-button',[_vm._v("Click me!")]),_c('o-button',{attrs:{"is-chive":""}},[_vm._v("No, click me!")]),_c('o-button',{attrs:{"is-red-onion":""}},[_vm._v("I'm nice and silent.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }